<div class="w-full flex items-center justify-center px-4 md:px-32 py-40">
  <div class="flex flex-col items-center justify-center gap-6">
    <img src="assets/page-not-found.png" alt="page-not-found" class="h-20" />
    <div class="flex flex-col gap-2 justify-center items-center text-center">
      <h2 nz-typography>{{ 'pages.not-found.title' | translate }}</h2>
      <p nz-typography nzType="secondary">{{ 'pages.not-found.text' | translate }}</p>
    </div>
  </div>
</div>
